export const useApi = () => {
  const config = useRuntimeConfig();
  const apiUrl = config.public.apiUrl;
  const apiUrlForServer = config.public.apiUrlForServer;
  const currentApiUrl = process.server ? apiUrlForServer : apiUrl;

  const apiService = {
    get: async (url: string, params: any = {}) => {
      try {
        return await $fetch(`${currentApiUrl}/${url}`, {
          method: 'GET',
          params,
        });
      } catch (error: any) {
        console.error('API GET Error:', error.message);
        throw error;
      }
    },
    post: async (url: string, body: any = {}) => {
      try {
        return await $fetch(`${currentApiUrl}/${url}`, {
          method: 'POST',
          body,
        });
      } catch (error: any) {
        console.error('API POST Error:', error.message);
        throw error;
      }
    },
  }

  return {
    apiService,
  }
}